import { render, staticRenderFns } from "./ProfileAdmin.vue?vue&type=template&id=af245c0a&scoped=true"
import script from "./ProfileAdmin.vue?vue&type=script&lang=js"
export * from "./ProfileAdmin.vue?vue&type=script&lang=js"
import style0 from "./ProfileAdmin.vue?vue&type=style&index=0&id=af245c0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af245c0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
